import { render, staticRenderFns } from "./QuestionTextarea.vue?vue&type=template&id=1b467a94&scoped=true"
import script from "./QuestionTextarea.vue?vue&type=script&lang=js"
export * from "./QuestionTextarea.vue?vue&type=script&lang=js"
import style0 from "./QuestionTextarea.vue?vue&type=style&index=0&id=1b467a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b467a94",
  null
  
)

export default component.exports